(function captionBar(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.FullImageViewerState ||
    !global.NewHomeSource.FullImageViewer.Config) {
    return;
  }

  const previousCaptionBar = global.NewHomeSource.CaptionBar;
  const headerElement = global.document.querySelector('[data-full-image-viewer-role="caption-header"]');
  const subtextElement = global.document.querySelector('[data-full-image-viewer-role="caption-subtext"]');

  /**
   * @public
   * render: renders the caption bar.
   *
   * @param {object} data information that is needed to render the caption bar.
   */
  function render(data) {
    const isVisible = global.NewHomeSource.FullImageViewer.Config.isCaptionBarVisible(data);
    const title = isVisible ? data.Title : '';
    const subtitle = isVisible && data.Title !== data.Description ? data.Description : '';

    headerElement.innerHTML = title;
    subtextElement.innerHTML = subtitle;
  }

  /**
  * @constructs NewHomeSource.CaptionBar
  */
  function CaptionBar() {
  }

  /**
   * @public
   * update: this method will be called by the Event Bus when the data is updated.
   *
   * @param {object} data information that was changed.
   */
  CaptionBar.update = function update(data) {
    requestAnimationFrame(render.bind(this, data));
  };

  /**
  * @public
  *
  * noConflict: Returns control of NewHomeSource.CaptionBar to the previous script.
  */
  CaptionBar.noConflict = function noConflict() {
    global.NewHomeSource.CaptionBar = previousCaptionBar;
    return CaptionBar;
  };

  global.NewHomeSource.FullImageViewerState.add('onImageSet', CaptionBar);
  global.NewHomeSource.CaptionBar = CaptionBar;
}(window));
